module.exports = __webpack_public_path__ + "img/selected4-min.026dad31.png";